export default __webpack_public_path__ + "static/media/dogecoin.0b11fab7.webp";